import { createAction, handleActions } from 'redux-actions';

export const beginGlobalLoad = createAction('@redux-conn/BEGIN_GLOBAL_LOAD');
export const endGlobalLoad = createAction('@redux-conn/END_GLOBAL_LOAD');
export const loadSuccess = createAction(
  '@redux-conn/LOAD_SUCCESS',
  (key: string, data: any) => ({ key, data }),
);

const initialState = {
  loaded: false,
  loadState: {},
};

export const reducer = handleActions(
  {
    '@redux-conn/BEGIN_GLOBAL_LOAD': (state) => ({
      ...state,
      loaded: false,
    }),
    '@redux-conn/END_GLOBAL_LOAD': (state) => ({
      ...state,
      loaded: true,
    }),
    '@redux-conn/LOAD_SUCCESS': (
      state,
      { payload: { key, data } }: { payload: { key: string; data: any } },
    ) => ({
      ...state,
      loadState: {
        ...state.loadState,
        [key]: { loading: false, loaded: true },
      },
      [key]: data,
    }),
  },
  initialState,
);
